var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"d-flex aling-center"},[_c('p',{staticClass:"f-12"},[_vm._v(_vm._s(_vm.fechaInforme))]),_c('i',{staticClass:"icon-search cr-pointer f-12",on:{"click":function($event){_vm.$emit('clicked');_vm.createTimer()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }